<template>
  <v-container>
    <v-row>
      <v-col>
        <CriteriaGroupListingComponent :yearId="yearId" @snack="throwSnack" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CriteriaListingComponent :yearId="yearId" @snack="throwSnack" />
      </v-col>
    </v-row>
    <v-row>
      <CriteriaTeamLevelComponent :year-id="yearId" @snack="throwSnack" />
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IYearDTO } from '@/dtos';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import CriteriaGroupListingComponent from '@/components/criteria/CriteriaGroupListingComponent.vue';
import CriteriaListingComponent from '@/components/criteria/CriteriaListingComponent.vue';
import CriteriaTeamLevelComponent from '@/components/criteria/CriteriaTeamLevelComponent.vue';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  year: IYearDTO;
}
const props = defineProps<Props>();
const yearId = computed(() => props.year.id);
</script>

<style scoped></style>
